import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, Navigate, useParams } from 'react-router-dom';
import Header from '../Header/Header';
import { CartContext } from '../Cart/CartContext';
import { FaRegBookmark } from 'react-icons/fa';
import { WishlistContext } from '../Wishlist/WishlistContext';
import Footer from '../Footer/Footer';
import { AiOutlineFrown } from 'react-icons/ai';
import { FcBookmark } from "react-icons/fc";

import ReactCountryFlag from "react-country-flag";
import { countryCodeMap } from "../countryMap/countryMap";


const CategoryPage = () => {
    const { categoryName } = useParams();
    const { addToCart, cartItems, removeFromCart } = useContext(CartContext);
    const { addToWishlist } = useContext(WishlistContext);

    const [products, setProducts] = useState([]);
    const [selectedVariants, setSelectedVariants] = useState({});
    const [quantities, setQuantities] = useState({});
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);



    useEffect(() => {
        axios.get('https://api.glocart.in/pages/api/products/get')
            .then(res => {
                let filtered = res.data;
                if (categoryName) {
                    filtered = filtered.filter(
                        p => p.category.toLowerCase() === categoryName.toLowerCase()
                    );
                }
                if (selectedSubcategory) {
                    filtered = filtered.filter(
                        p => p.sub_category?.toLowerCase() === selectedSubcategory.toLowerCase()
                    );
                }
                setProducts(filtered);
                const defaultVariants = {};
                const defaultQuantities = {};
                filtered.forEach(p => {
                    const matchingCartItem = cartItems.find(ci => ci.productId === p.id);
                    let selectedVariant;
                    if (matchingCartItem) {
                        selectedVariant = p.variants.find(v => v.id === matchingCartItem.variantId);
                        defaultQuantities[p.id] = matchingCartItem.quantity;
                    } else {
                        selectedVariant = p.variants[0];
                        defaultQuantities[p.id] = 0;
                    }
                    defaultVariants[p.id] = selectedVariant;
                });
                setSelectedVariants(defaultVariants);
                setQuantities(defaultQuantities);
            })
            .catch(err => console.error('Error fetching products:', err));
    }, [categoryName, selectedSubcategory, cartItems]);

    useEffect(() => {
        setSelectedSubcategory(null);
    }, [categoryName]);

    const [wishlist, setWishlist] = useState({}); // mapping key -> true

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;

        const fetchWishlist = () => {
            axios
                .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
                .then((res) => {
                    const wishMap = {};
                    res.data.forEach((item) => {
                        const key = `${item.productId}_${item.variantId}`;
                        wishMap[key] = true;
                    });
                    setWishlist(wishMap);
                })
                .catch((err) => console.error('Error fetching wishlist:', err));
        };

        // Initial fetch
        fetchWishlist();

        // Fetch every 1 second
        const intervalId = setInterval(fetchWishlist, 1000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, []);


    return (
        <>
            <Header />
            <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20, display: 'flex', gap: 20 }}>


                {/* Product Grid */}
                <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: 20 }}>
                    {products.length === 0 ? (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '60vh',
                                padding: '40px 20px',
                                textAlign: 'center',
                                textAlignLast: 'center',
                            }}
                        >
                            <AiOutlineFrown size={80} color="#0057A0" />
                            <h4 className="mt-4 text-muted" style={{ fontWeight: 'bold' }}>
                                No products found for "<span style={{ color: '#0057A0' }}>{categoryName?.replace('-', ' ')}</span>"
                            </h4>
                            <p className="text-secondary" style={{ marginTop: 10 }}>
                                Try exploring other categories or filters.
                            </p>

                            <button
                                onClick={() => Navigate('/')}
                                style={{
                                    marginTop: 20,
                                    backgroundColor: '#0057A0',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '10px 24px',
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#b71c1c')}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0057A0')}
                            >
                                🛒 Shop Now
                            </button>
                        </div>

                    ) : (
                        products.map(p => {
                            const selected = selectedVariants[p.id] || p.variants[0];
                            const hasDiscount = selected.discount > 0;
                            const price = selected.price - (selected.price * selected.discount) / 100;
                            const quantity = quantities[p.id] || 0;


                            const key = `${p.id}_${selected?.id}`;
                            const isWishlisted = wishlist[key];

                            return (
                                <div key={p.id} style={{ border: '1px solid #e0e0e0', background: '#fff', position: 'relative', borderRadius: '10px' }}>
                                    {hasDiscount && (
                                        <div style={{
                                            position: 'absolute', top: 8, left: 8, background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)",
                                            color: '#0058A2',
                                            fontWeight: 'bold', padding: '2px 6px', fontSize: 12, borderRadius: '10px'
                                        }}>{selected.discount}% OFF</div>
                                    )}
                                    <div className="mx-3 mt-3 mb-1 p-2" style={{ border: '1px solid #eee', borderRadius: '10px', backgroundColor: '#fff', }}>
                                        <Link to={`/product/${p.id}`}>
                                            <img src={p.image_1} alt={p.name} style={{ width: '100%', height: 180, objectFit: 'contain', background: '#fafafa' }} />
                                        </Link>
                                    </div>
                                    <div style={{ padding: 10 }}>
                                        <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <ReactCountryFlag
                                                countryCode={countryCodeMap[p.super_category]}
                                                svg
                                                style={{ width: '18px', height: '18px' }}
                                            />
                                            {p.super_category}
                                        </p>
                                        <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>⚡ {p.category}</p>
                                        <p style={{ fontSize: 13, margin: 0 }}>{p.brand}</p>
                                        <h4 style={{ fontSize: 14, margin: '4px 0 8px' }}>{p.name}</h4>


                                        {/* Custom Variant Dropdown */}
                                        <div style={{ position: 'relative', marginBottom: 10 }}>
                                            <div style={{ border: '1px solid #ccc', padding: '6px 8px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px' }}
                                                onClick={() => setSelectedVariants(prev => ({ ...prev, [p.id + '_open']: !prev[p.id + '_open'] }))
                                                }>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                    <span style={{ fontWeight: 'bold' }}>₹{Math.round(price)}</span>
                                                    {selected.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{selected.price}</span>)}
                                                    {selected.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{selected.discount}% OFF</span>)}
                                                </div>
                                            </div>

                                            {selectedVariants[p.id + '_open'] && (
                                                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                    {p.variants.map((v, idx) => {
                                                        const discPrice = Math.round(v.price - (v.price * v.discount) / 100);
                                                        return (
                                                            <div key={v.id} onClick={() => {
                                                                setSelectedVariants(prev => ({ ...prev, [p.id]: v, [p.id + '_open']: false }));
                                                                const cartItem = cartItems.find(ci => ci.productId === p.id && ci.variantId === v.id);
                                                                setQuantities(prev => ({ ...prev, [p.id]: cartItem ? cartItem.quantity : 0 }));
                                                            }} style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: selected.id === v.id ? '#f6f6f6' : 'white', cursor: 'pointer', fontSize: '13px' }}>
                                                                <div>
                                                                    <strong>{v.unit_value} {v.unit}</strong>{' '}
                                                                    {v.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{v.discount}% OFF</span>)}
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                                    <span style={{ fontWeight: 'bold' }}>₹{discPrice}</span>
                                                                    {v.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{v.price}</span>)}
                                                                    <span style={{ fontSize: '11px', backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚡ ADD</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>


                                        {/* Price */}
                                        <div style={{ fontSize: 15, fontWeight: 'bold' }}>
                                            ₹{price.toFixed(0)}
                                            {hasDiscount && (<span style={{ fontSize: 13, color: '#999', textDecoration: 'line-through', marginLeft: 6 }}>₹{selected.price}</span>)}
                                        </div>

                                        {/* Wishlist & Cart Buttons */}
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
                                            {/* Wishlist */}
                                            <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                onClick={() => {
                                                    addToWishlist(p, selected);
                                                    // alert(`${p.name} saved to wishlist!`);
                                                    alert(
                                                        isWishlisted
                                                            ? `${p.name} removed from wishlist!`
                                                            : `${p.name} saved to wishlist!`
                                                    );
                                                }}>
                                                {/* <FaRegBookmark /> */}
                                                {isWishlisted ? (
                                                    <FcBookmark size={22} />     // filled icon
                                                ) : (
                                                    <FaRegBookmark size={22} />   // empty icon
                                                )}
                                            </button>

                                            {/* Cart Controls */}
                                            {quantity > 0 ? (
                                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                    <button
                                                        onClick={() => {
                                                            const newQty = quantity - 1;

                                                            if (newQty <= 0) {
                                                                setQuantities(prev => ({ ...prev, [p.id]: 0 }));
                                                                removeFromCart(p.id, selected.id);
                                                            } else {
                                                                setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                                addToCart({
                                                                    id: selected.id,
                                                                    productId: p.id,
                                                                    name: p.name,
                                                                    image: p.image_1,
                                                                    price,
                                                                    type: selected.type,
                                                                    variantId: selected.id
                                                                }, -1);
                                                            }
                                                        }}

                                                        style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                    >
                                                        –
                                                    </button>
                                                    <div style={{ padding: '6px 12px', fontSize: 14 }}>{quantity}</div>
                                                    <button
                                                        onClick={() => {
                                                            const newQty = quantity + 1;
                                                            setQuantities(prev => ({ ...prev, [p.id]: newQty }));
                                                            addToCart({
                                                                id: selected.id,
                                                                productId: p.id,
                                                                name: p.name,
                                                                image: p.image_1,
                                                                price,
                                                                type: selected.type,
                                                                variantId: selected.id
                                                            }, 1);
                                                        }}
                                                        style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        setQuantities(prev => ({ ...prev, [p.id]: 1 }));
                                                        addToCart({
                                                            id: selected.id,
                                                            productId: p.id,
                                                            name: p.name,
                                                            image: p.image_1,
                                                            price,
                                                            type: selected.type,
                                                            variantId: selected.id
                                                        }, 1);
                                                    }}
                                                    style={{ padding: '6px 90px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }}
                                                >
                                                    Add
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default CategoryPage;
